/**
 * Первый непустой адрес из цепочки «серверный вариант → оригинал» (19243).
 *
 * Варианты (`cover_card_url`, `photo_card_url`, `logo_square_url` …) приходят с
 * бэка 19244 и есть не у всех записей: до выкладки, у записей без файла и в
 * ответах, которые варианты не отдают. Слот обязан показать оригинал в своей
 * рамке, а при пустой цепочке — заглушку, которую подставляет вызывающий
 * (`pickImageUrl(...) || CoverPlaceholderS`).
 * @param urls - адреса по убыванию предпочтения
 */
export const pickImageUrl = (...urls: (string | null | undefined)[]): string =>
  urls.find((url): url is string => Boolean(url)) ?? '';
